var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -8.139,
    x2: 96.987,
    y1: 3.122,
    y2: 107.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#551067",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#551067",
    offset: 0.085
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#551067",
    offset: 0.222
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#551067",
    offset: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#551067",
    offset: 0.595
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#551067",
    offset: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#551067",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M77.369 43.137h-2.142v-15.41C75.227 13.817 63.91 2.5 50 2.5S24.773 13.817 24.773 27.727v15.41h-2.142c-6.17 0-11.165 5.006-11.165 11.165v32.022c0 6.17 4.996 11.176 11.165 11.176H77.37c6.17 0 11.165-5.006 11.165-11.176V54.302c0-6.16-4.996-11.165-11.165-11.165zM55.102 72.213v9.105a5.102 5.102 0 1 1-10.204 0v-9.105a9.693 9.693 0 0 1-4.633-8.273c0-5.369 4.366-9.724 9.735-9.724s9.735 4.355 9.735 9.724a9.693 9.693 0 0 1-4.633 8.273zm8.954-29.076H35.944v-15.41c0-7.751 6.305-14.056 14.056-14.056s14.056 6.305 14.056 14.056z",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.8d2ecf2630ec9c84ae6d43651576dcd9.svg";
export { ForwardRef as ReactComponent };